<mat-form-field class="xp-phone-field__code"
                appearance="outline"
                subscriptSizing="dynamic">
	<input matInput [value]="countryCode()" readonly tabindex="-1" />
</mat-form-field>
<mat-form-field class="xp-phone-field__number"
                appearance="outline"
                subscriptSizing="dynamic">
	<input matInput
	       [ngModel]="value()"
	       (ngModelChange)="value.set($event)"
	       [placeholder]="placeholder()"
	       [attr.maxlength]="maxLength()"
	       inputmode="numeric"
	       autocomplete="tel-national" />
	<button *ngIf="value()"
	        mat-icon-button
	        matSuffix
	        type="button"
	        aria-label="Clear phone number"
	        (click)="clear.emit()">
		<mat-icon>close</mat-icon>
	</button>
</mat-form-field>
